import { render, staticRenderFns } from "./engbill.vue?vue&type=template&id=6ec1a12e&scoped=true"
import script from "./engbill.vue?vue&type=script&lang=js"
export * from "./engbill.vue?vue&type=script&lang=js"
import style0 from "./engbill.vue?vue&type=style&index=0&id=6ec1a12e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec1a12e",
  null
  
)

export default component.exports